import React, { Fragment, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

import close_icon from '@/assets/images/close_icon.png'
import qw_success from '@/assets/images/qw_success.png'

interface IProps {
  qrCode: string
  setQwCodeState: (state: boolean) => void
}
export default ({ qrCode, setQwCodeState }: IProps) => {
  return (
    <Container className="qwModal">
      <div className="mask" onClick={() => setQwCodeState(false)}></div>
      <div className="content">
        <img src={close_icon} className="close_icon" onClick={() => setQwCodeState(false)} />
        <img src={qw_success} className="img" />
        <p className="title">领课成功</p>
        <p className="sub_tit">请务必添加老师，否则影响学习体验</p>
        <div className="tip">
          <p>体验指导</p>
          <p className="line"></p>
          <p>答疑解惑</p>
          <p className="line"></p>
          <p>个性化服务</p>
          <p className="line"></p>
          <p>专属福利</p>
        </div>
        <div className="code_wrapper">
          <img src={qrCode} alt="" />
        </div>
        <div className="text">立即扫码识别添加老师微信</div>
        <div className="sub_tip">*如已添加请忽略</div>
      </div>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }
  .close_icon {
    width: 54px;
    height: 54px;
    position: absolute;
    right: 0;
    top: -84px;
    cursor: pointer;
  }
  .content {
    text-align: center;
    position: relative;
    top: 50%;
    left: 50%;
    margin-left: -341px;
    margin-top: -341px;
    width: 682px;
    height: 682px;
    background: linear-gradient(180deg, #ffffff 0%, #ffffff 86%, #ffbbbb 100%);
    border-radius: 30px;
    padding-top: 96px;
    transform: scale(0.7);
  }
  .img {
    width: 142px;
    height: 158px;
    display: block;
    position: absolute;
    top: -71px;
    left: 50%;
    transform: translateX(-50%);
  }
  .title {
    font-size: 48px;
    font-weight: 500;
    color: #2f2f2f;
    line-height: 67px;
    text-align: center;
    margin-top: 0;
  }
  .sub_tit {
    font-size: 36px;
    font-weight: 500;
    color: #000000;
    line-height: 50px;
    margin: 8px auto;
    text-align: center;
  }
  .tip {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    margin-bottom: 29px;
  }
  .line {
    width: 1px;
    background: #979797;
    height: 24px;
    margin: 0 14px;
  }
  .code_wrapper {
    width: 240px;
    height: 240px;
    background: #d8d8d8;
    margin: 0 auto 20px;
  }
  .code_wrapper img {
    width: 100%;
    height: 100%;
  }
  .text {
    font-size: 34px;
    font-weight: 500;
    color: #fc5323;
    line-height: 48px;
    margin-bottom: 12px;
  }
  .sub_tip {
    font-size: 24px;
    font-weight: 400;
    color: #666666;
    line-height: 33px;
  }
`
